import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import useAuth from '../../Hooks/useAuth';
import axios from '../../Api/axios';
import {
  Checkbox,
  FeedbackText,
  Forgottext,
  FormHeader,
  LoginButton,
  LoginContainer,
  LoginForm,
  LoginInput,
  LoginSectionLeft,
  LoginSectionRight,
  LoginWrapper,
  LogoImage,
  MobileLogo,
  Remembertext,
  RememberWrapper,
  SignUptext,
  SignUpTextLink,
  SignUpWrapper,
  TextWrapper,
} from './loginElements';
import Logo from '../../Images/General/logoWhite.png';
import Logo2 from '../../Images/General/Logo.png';

const LoginSection = () => {
  const { setAuth, persist, setPersist } = useAuth();

  const navigate = useNavigate();
  const location = useLocation();
  const from = location.state?.from?.pathname || '/';

  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');

  const [feedback, setFeedback] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!email || !password) {
      setFeedback('E-mail and password cant be empty!');
      return;
    }

    try {
      axios.post(
        '/login',
        JSON.stringify({
          email,
          password,
        }),
        {
          headers: { 'Content-Type': 'application/json' },
          withCredentials: true,
        },
      ).then((res) => {
        if (res.data.status === 'success') {
          const {
            accessToken, roles, name, surname, phone, company, handle, social, wallet, verified,
          } = res.data;
          setAuth({
            email,
            password,
            accessToken,
            roles,
            name,
            surname,
            phone,
            company,
            handle,
            social,
            wallet,
            verified,
          });
          setFeedback(res.data.message);
          navigate(from, { replace: true });
        } else setFeedback(res.data.message);
      }).catch((error) => {
        if (error.response.status === 400
          || error.response.status === 401) setFeedback(error.response.data.message);
        else if (error) setFeedback('No server response!');
        else {
          setFeedback('Something went wrong');
          console.log('Error', error.message);
        }
      });
    } catch (err) {
      if (!err?.response) setFeedback('No server response');
      else setFeedback('Login failed');
    }
  };

  const togglePersist = () => {
    setPersist((prev) => !prev);
  };

  useEffect(() => {
    localStorage.setItem('persist', persist);
  }, [persist]);

  // Error handling
  useEffect(() => {
    setFeedback('');
  }, [email, password]);

  return (
    <LoginContainer>
      <LoginWrapper>
        <LoginSectionLeft>
          <LogoImage src={Logo} />
        </LoginSectionLeft>
        <LoginSectionRight>
          <MobileLogo src={Logo2} />
          <FormHeader>Login</FormHeader>
          <LoginForm onSubmit={handleSubmit}>
            <LoginInput
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="E-mail"
              type="email"
              name="email"
            />
            <LoginInput
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Password"
              type="password"
              name="password"
            />
            <TextWrapper>
              <RememberWrapper>
                <Checkbox type="checkbox" onChange={togglePersist} checked={persist} />
                <Remembertext>Trust this device</Remembertext>
              </RememberWrapper>
              <Forgottext href="forgot_password">Forgot Password?</Forgottext>
            </TextWrapper>
            <FeedbackText>{feedback}</FeedbackText>
            <LoginButton type="submit">Login</LoginButton>
            <SignUpWrapper>
              <SignUptext>
                {'Don\'t have an account yet?'}
              &nbsp;
              </SignUptext>
              <SignUpTextLink href="/register">Sign Up!</SignUpTextLink>
            </SignUpWrapper>
          </LoginForm>
        </LoginSectionRight>
      </LoginWrapper>
    </LoginContainer>
  );
};

export default LoginSection;
